import CandidateSignUpForm from "@/components/authForms/CandidateSignUpForm";
import EntryLayout from "@/components/layout/EntryLayout";
import React from "react";

const Referral = () => {
  return (
    <>
      <EntryLayout
        formPanel={<CandidateSignUpForm />}
        greetingTitle={"Create an account to activate your referral link"}
        greetingSubTitle={`With our refer & earn program, you can earn up to ₹10,000 for every candidate you refer to our platform who signs up and gets hired. Don't miss out on this opportunity to make your network work for you. Sign up with Zelevate today and start referring your talented friends to earn big rewards and cash prizes!`}
      />
    </>
  );
};

export default Referral;
